
import { Info } from "../User";
import Typewriter from "typewriter-effect";
import { Button, useMatches } from "@mantine/core";
import ResumeViewer from "./ResumeViewer";
import { useDisclosure } from "@mantine/hooks";
import { IconDownload } from "@tabler/icons-react";
import Particles from "./magicui/Particles";
import { NeonGradientCard } from "./magicui/neon-gradient-card";
const About = () => {
    const [opened, { open, close }] = useDisclosure(false);
    const btn =useMatches({
        xs:'xs',
        sm:'sm',
        md:'md',
        lg:'lg'
    })
    return (
        <>
            <div data-aos="zoom-out-up" data-aos-duration="800" className="mt-28 flex relative overflow-hidden justify-around items-center font-mono px-10 py-10 md-mx:px-6 sm-mx:px-4 xs-mx:px-2 xs-mx:py-4 h-120 lg-mx:justify-between bs-mx:flex-wrap bs-mx:flex-col-reverse bs-mx:!overflow-visible bs-mx:gap-6" id="About">
                <Particles
                    className="absolute -z-20 inset-0"
                    quantity={2000}
                    ease={80}
                    vx={.1}
                    vy={.1}
                    color="#64FFDA"
                    refresh
                />
                <div className="bs:ml-10 bs:w-3/5 flex flex-col lg-mx:gap-3  bs-mx:items-center">
                    <div className="text-primaryColor text-2xl lg-mx:text-xl sm-mx:text-lg xs-mx:text-base xsm-mx:text-sm"><span className="text-white">Hi,</span> I'm</div>
                    <div className="text-white text-[3.5rem] font-extrabold lg-mx:text-[2.75rem] md-mx:text-4xl sm-mx:text-3xl xs-mx:text-2xl xsm-mx:text-xl">{Info.name}</div>
                    <div className="text-white text-3xl flex font-semibold lg-mx:text-2xl md-mx:text-xl sm-mx:text-lg xs-mx:text-base xsm-mx:text-sm">A&nbsp;<span className="text-primaryColor"><Typewriter options={{ strings: Info.stack, autoStart: true, loop: true, }} /> </span></div>
                    <div className="text-textColor text-lg w-[90%] text-justify my-6 lg-mx:my-4 lg-mx:text-base md-mx:text-sm sm-mx:text-sm xs-mx:text-xs">{Info.bio}</div>
                    <div className="xs-mx:w-[90%] flex gap-3 xs-mx:justify-between">
                        <Button onClick={open} className="focus-visible:!outline-none !text-bgColor !w-fit xs-mx:!w-[46%]" size={btn} variant="filled" color="#64FFDA">Check Resume</Button>
                        <Button component="a" href="Resume-cv.pdf" download={Info.name} className="focus-visible:!outline-none !text-primaryColor !w-fit xs-mx:!w-[46%]" size={btn} variant="outline" color="#64FFDA" rightSection={<IconDownload size={20} />}>Download</Button>
                    </div>
                </div>
                <div className="h-fit flex justify-center items-center rounded-full bs:mr-10 w-fit">
                    <NeonGradientCard className="w-[280px] h-[280px] lg-mx:w-[240px] lg-mx:h-[240px] md-mx:w-52 md-mx:h-52 sm-mx:w-44 sm-mx:h-44 xs-mx:w-40 xs-mx:h-40 xsm-mx:w-36 xsm-mx:h-36 items-center justify-center text-center">
                        <img className="w-full h-full object-cover rounded-full " src="7.png" alt="profile" />
                    </NeonGradientCard>
                </div>
            </div>
            <ResumeViewer opened={opened} close={close} />
        </>
    )
}
export default About;